import GameEvents from "../../src/const/GameEvents";
import InstanceFactory from "../../src/factories/InstanceFactory";
import GameModel from "../../src/model/GameModel";
import LocalData from "../utils/LocalData";
import App from "../App";
import { Tween } from "../Tween";
import SoundController from "../utils/SoundController";
import Layout from "../utils/Layout";
import { Container, utils as PixiUtils } from "pixi.js";
import EventEmitter = PixiUtils.EventEmitter;
import ConsoleUtil from "../utils/ConsoleUtil";

/**
 * BaseView - abstraction for a display object container with utility methods.
 * Automatically destroyed when removed from the scene.
 */
class BaseView extends Container {

    public tweens: Tween[];
    public events: IEventDefinition[];
    public defaultLayer: string;
    protected supportOrientationChange;
    protected orientation:ViewOrientation;
    protected alphaTween: Tween;

    constructor(supportOrientationChange = false)
    {
        super();
        // this.once('removed', this.destroy, this);
        this.orientation = Layout.isLandscape() ? ViewOrientation.Landscape : ViewOrientation.Portrait;
        this.tweens = [];
        this.events = [];
        this.supportOrientationChange = supportOrientationChange;
        if (GameModel.isMobile() && this.supportOrientationChange) {
            this.addEventListener(this.dispatcher, GameEvents.RESIZE, this.onOrientationChange, this);
        }
    }

    public setVisible(visible: boolean) {
        this.visible = visible;
    }

    public setEnabled(enabled: boolean)
    {
        this.interactive = enabled;
        if (this.alphaTween) {
            this.alphaTween.kill();
        }

        this.alphaTween = Tween.to(this, 0.25, {alpha: 0.5 + 0.5 * Number(enabled)});
    }

    public create(...args: any[]) {
        // TODO
    }

// TODO REMOVE INJECTION
get layout() { return Layout; }
get sound() { return SoundController; }
get config() { return App.config; }
get assets() { return App.assets; }
get dispatcher() { return App.dispatcher; }
get locale() { return App.locale; }
get localData() { return LocalData; }
get gameFactory() { return InstanceFactory; }


    /**
     * Add a listener which is automatically disposed when the view is disposed
     * @param emitter
     * @param eventType
     * @param callback
     * @param scope
     */
    public addEventListener(emitter: EventEmitter, eventType: string, callback: (...args: any[]) => void, scope?: any)
    {
        this.events.push({ emitter, eventType, callback, scope});
        emitter.on(eventType, callback, scope);
    }

    /**
     * Not fully implemented.
     * The idea is to keep track of all delayed calls so they can be killed when the view is destroyed.
     * @param delay
     * @param callback
     * @param args
     * @param scope
     * @returns {Tween}
     */
    public addDelayedCall(delay: number, callback: (...args: any[]) => void, args?: any[], scope?: any)
    {
        return Tween.delayedCall(delay, callback, args, scope);
    }


    /**
     * Convenience function.
     */
    public removeFromParent()
    {
        if (this.parent)
        {
            this.parent.removeChild(this);
        }
    }


    /**
     * Dispose of the object, called automatically when removed from stage
     */
    public destroy(options?)
    {
        const numTweens = this.tweens.length;
        for (let tweenIdx = 0; tweenIdx < numTweens; tweenIdx++)
        {
            const t = this.tweens[tweenIdx];
            t.kill();
        }

        for (let evtIdx = 0; evtIdx < this.events.length; evtIdx++)
        {
            const evtData = this.events[evtIdx];
            const emitter = evtData.emitter;
            emitter.removeListener(evtData.eventType, evtData.callback, evtData.scope);
        }

        this.removeChildren();
        this.removeAllListeners();
        super.destroy(options);
    }

    public onOrientationChange(orientationChanged = true) {
        if (!orientationChanged) {
            return;
        }
        const newOrientetion = Layout.isLandscape() ? ViewOrientation.Landscape : ViewOrientation.Portrait;
        if (this.orientation != newOrientetion) {
            this.changeOrientation(newOrientetion);
        }
    }

    protected changeOrientation(newOrientetion: ViewOrientation) {
        ConsoleUtil.log("onOrientationChange baseVIEW");
    }

    public removeEventListener(event: string) {
        for (let i = 0; i < this.events.length; i++) {
            if (this.events[i].eventType == event) {
                this.events[i].emitter.removeListener(this.events[i].eventType, this.events[i].callback, this.events[i].scope);
                this.events.splice(i, 1);
                break;
            }
        }
    }


}

export interface IEventDefinition {
    emitter: EventEmitter;
    eventType: string;
    callback(...args: any[]): void;
    scope?: any
}

export enum ViewOrientation {
    Landscape = "Landscape",
    Portrait = "Portrait"
}

export default BaseView;
